document.addEventListener("DOMContentLoaded", function () {
  let lazyLoadInstance;
  init();
});

function init() {
  let body = document.querySelector("body");
  let buttonToggles = document.querySelectorAll("[data-toggle]");

  // LazyLoad
  lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazyload",
  });

  // Toggle Class
  buttonToggles.forEach((button, i) => {
    button.addEventListener("click", (event) => {
      body.classList.toggle(button.getAttribute("data-toggle"));
    });
  });

  // Theme Preview
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:reorder", function () {
      lazyLoadInstance.update();
    });
    document.addEventListener("shopify:section:load", function () {
      lazyLoadInstance.update();
    });
  }

  // Page Specific
  page_home(body);
  page_cart(body);

  // Layouts
  layout_hero();
  layout_video();
  layout_product();
  layout_quantity();
  layout_minicart();
}

function layout_minicart() {
  let minicart = document.querySelector(".layout-minicart");

  if (minicart) {
    const minicartModal = new A11yDialog(minicart);
    let headerMenuMinicart = document.querySelector(".header-menu-minicart");
    let miniCartOpen = false;

    if (headerMenuMinicart) {
      headerMenuMinicart.addEventListener("click", (event) => {
        event.preventDefault();
        if (!miniCartOpen) {
          minicartModal.show();
        } else {
          minicartModal.hide();
        }
      });
    }
    // Track state
    minicartModal.on("show", function (event) {
      miniCartOpen = true;
    });
    minicartModal.on("hide", function (event) {
      miniCartOpen = false;
    });

    // Cart reload
    document.addEventListener("liquid-ajax-cart:request-end", (event) => {
      const { requestState } = event.detail;

      // Update lazyload
      lazyLoadInstance.update();

      // If the "add to cart" request is successful
      if (requestState.requestType === "add" && requestState.responseData?.ok) {
        // Show minicart
        minicartModal.show();

        // Scroll to top
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }
    });
  }
}

function page_cart(body) {
  if (body.classList.contains("page-cart")) {
    // Allow removing items on the basket page
    liquidAjaxCart.conf("quantityTagAllowZero", true);
  }
}

function page_home(body) {
  if (body.classList.contains("page-home")) {
    // Menu : Deep link menu items
    let headerMenuItem = document.querySelectorAll(".header-menu-item");

    headerMenuItem.forEach((menuItem, i) => {
      menuItem.addEventListener("click", (event) => {
        if (menuItem.href.indexOf("#") > -1) {
          event.preventDefault();
          hash = menuItem.href.split("#")[1];
          section = document.querySelector('section[data-name="' + hash + '"]');
          if (section) {
            window.scrollTo({
              top: section.getBoundingClientRect().top,
              left: 0,
              behavior: "smooth",
            });
          }
        }
      });
    });

    // Deep link on load
    if (window.location.hash) {
      hash = window.location.hash.split("#")[1];
      section = document.querySelector('section[data-name="' + hash + '"]');
      if (section) {
        window.scrollTo({
          top: section.getBoundingClientRect().top,
          left: 0,
          behavior: "smooth",
        });
      }
    }
  }
}

function layout_quantity() {
  let quantities = document.querySelectorAll(".product-quantity");

  quantities.forEach((quantity, i) => {
    input = quantity.querySelector(".quantity-input");

    // Plus
    quantity
      .querySelector(".quantity-plus")
      .addEventListener("click", (event) => {
        event.preventDefault();
        quantityValue = parseInt(input.value) ? parseInt(input.value) : 0;
        input.value = quantityValue + 1;
      });

    // Minus
    quantity
      .querySelector(".quantity-minus")
      .addEventListener("click", (event) => {
        event.preventDefault();
        quantityValue = parseInt(input.value) ? parseInt(input.value) : 0;
        if (quantityValue >= 1) {
          input.value = quantityValue - 1;
        }
      });
  });
}

function layout_hero() {
  let hero = document.querySelector(".layout-hero");
  if (hero) {
    // Hero
    const swiper = new Swiper(hero.querySelector(".swiper"), {
      loop: true,
      effect: "fade",
      speed: 1000,
      fadeEffect: {
        crossFade: true,
      },
      parallax: {
        enabled: true,
      },
      pagination: {
        el: ".gallery-pagination",
        bulletClass: "gallery-bullet",
        bulletActiveClass: "gallery-bullet-active",
        clickable: true,
      },
    });
  }
}

function layout_product() {
  let product = document.querySelector(".layout-product");
  if (product) {
    // Gallery
    const swiper = new Swiper(product.querySelector(".swiper"), {
      loop: true,
      effect: "fade",
      speed: 3000,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: ".gallery-pagination",
        bulletClass: "gallery-bullet",
        bulletActiveClass: "gallery-bullet-active",
        clickable: true,
      },
    });

    // Gift Wrapping
    let giftWrappingCheckbox = document.querySelector(
      ".product-gift-wrapping-checkbox:checked"
    );

    if (giftWrappingCheckbox) {
      // Bind to the cart event
      document
        .querySelector(".button-add-to-cart")
        .addEventListener("click", function (event) {
          if (
            document.querySelector(".product-gift-wrapping-checkbox:checked")
              .value != "standard"
          ) {
            // Add the Gift wrapping to the cart
            const giftWrapProduct = {
              items: [
                {
                  id: Number(
                    document.querySelector(
                      ".product-gift-wrapping-checkbox:checked"
                    ).value
                  ),
                  quantity: document.querySelector('.product-quantity input').value,
                },
              ],
            };

            liquidAjaxCart.add(giftWrapProduct);
          }
        });
    }
  }
}

function layout_video() {
  let videos = document.querySelectorAll(".layout-video");
  const videoMediaQuery = window.matchMedia("(max-width: 768px)");

  if (videos) {
    videos.forEach((video, i) => {
      let videoElement = video.querySelector("video");
      let player = new Plyr(videoElement, {
        controls: [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "fullscreen",
        ],
      });

      // Set video source
      if (videoMediaQuery.matches) {
        // Mobile
        source = videoElement.dataset.mobile;
      } else {
        // Desktop
        source = videoElement.dataset.desktop;
      }
      player.source = {
        type: "video",
        sources: [
          {
            src: source,
            type: "video/mp4",
          },
        ],
        poster: videoElement.dataset.poster,
      };
    });
  }
}